import {keyBy} from "lodash-es";

import { PositionType, type PoolTabsType} from "modules/enums";
import type {TStore} from "modules/types/store";
import {createSelector} from "reselect";

export const getPlayersStore = (store: TStore) => store.players;
export const getPlayers = (store: TStore) => store.players.players;

export const getPlayerByIdSelector = createSelector(
	[getPlayers],
	(players) => (id: number) => players[id]
);

export const getPlayersByType = createSelector(
	[getPlayersStore],
	({players, poolPlayers}) =>
		(type?: PoolTabsType | null) => {
			const playerIds = type ? poolPlayers[type] : Object.keys(players).map(Number);

			return playerIds
				.map((playerId) => players[playerId])
				.filter(
					(player) => player.position !== PositionType.PITCHER || player.isPitcherHitter
				);
		}
);

export const getSuggestedPlayersByRoundId = createSelector(
	[getPlayersStore],
	(store) => (roundId: number) => {
		return keyBy(
			store.suggestedPlayers.filter((it) => it.roundId === roundId),
			"playerId"
		);
	}
);

export const getIsSuggestedPlayer = createSelector(
	[getSuggestedPlayersByRoundId],
	(playersSelector) => (roundId: number, playerId: number = 0) => {
		const players = playersSelector(roundId);
		return !!players[playerId];
	}
);

export const getMostSelectedPlayersByRoundId = createSelector(
	[getPlayersStore],
	(store) => (roundId: number) => {
		return keyBy(
			store.mostSelectedPlayers.filter((it) => it.roundId === roundId),
			"playerId"
		);
	}
);

export const getIsMostSelectedPlayer = createSelector(
	[getMostSelectedPlayersByRoundId],
	(playersSelector) => (roundId: number, playerId: number = 0) => {
		const players = playersSelector(roundId);
		return !!players[ playerId ];
	}
);

export const getSearchPlayer = createSelector([getPlayersStore], (store) => store.search);
